<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate [formGroup]="StudentEdit">
         <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    
                    <div class="page-header"> 
                        <div>
                            <h2 class="main-content-title tx-24 mg-b-5">All Student Records</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">Student Data</li>
                            </ol>
                        </div>

                    </div>
                    <div>

                    </div>
                    <div class="table-responsive">
                        <table id="datatable" class="table table-bordered text-left">
                            <thead>
                                <tr class="bgcolor">

                                    <th class="f600" >
                                        Name
                                    </th>
                                    <th class="f600" >
                                        Display
                                    </th>
                                    <th class="f600" >
                                        Pattern
                                    </th>
                                    <th class="f600">
                                        FormControlName
                                    </th>
                                    <th class="f600">
                                        Type
                                    </th>
                                    <th class="f600">
                                        Form Page
                                    </th>
                                    <th class="f600">
                                        Require
                                    </th>
                                    <th class="f600">
                                        Is Default
                                    </th>
                                    <th class="f600">
                                        Visible
                                    </th>
                                    <th class="f600">
                                        Add
                                    </th>
                                </tr>
                            </thead>
                            <tbody id="table_data" formArrayName="arrData">
                                <tr [formGroupName]="i"
                                    *ngFor="let value of Arr; let row of StudentEdit.get('arrData')['controls'];let i = index;">

                                    <td >
                                        <input width="40%" formControlName="FormName" class="form-control" value="{{value.name}}">
                                    </td>
                                    <td width="40%">
                                        <input width="40%" formControlName="FormDisplayName" class="form-control"
                                            value="{{value.display}}">
                                    </td>
                                    <td width="40%">
                                        <input width="40%" formControlName="FormPattern" class="form-control"
                                            value="{{value.pattern}}">
                                    </td>
                                    <td>
                                        <input formControlName="FormControlName" class="form-control"
                                            value="{{value.form}}">
                                    </td>
                                    <td>
                                        <mat-form-field>
                                            <mat-label>Choose an option</mat-label>
                                            <mat-select formControlName="FormType">
                                                <mat-option value="Input">
                                                    Input Field
                                                </mat-option>
                                                <mat-option value="Checkbox">
                                                    Checkbox
                                                </mat-option>
                                                <mat-option value="Dropdown">
                                                    Dropdown
                                                </mat-option>
                                                <mat-option value="RadioBtn">
                                                    Radio Button
                                                </mat-option>
                                                <mat-option value="MatTab">
                                                    Tab
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field>
                                            <mat-label>Choose an option</mat-label>
                                            <mat-select formControlName="FormPage">
                                                <mat-option value="PersonalDetails">
                                                    Personal Details
                                                </mat-option>
                                                <mat-option value="ContactDetails">
                                                    Contact Details
                                                </mat-option>
                                                <mat-option value="ReserveDetails">
                                                    Reservation Details
                                                </mat-option>
                                                <mat-option value="QualifyDetails">
                                                    Qualification Details
                                                </mat-option>
                                                <mat-option value="AdditionalDetail">
                                                    Additional Details
                                                </mat-option>
                                                <mat-option value="PhotoSign">
                                                    Photo & Signature
                                                </mat-option>
                                                <mat-option value="AdmDetails">
                                                    Admission Details
                                                </mat-option>
                                                <mat-option value="Documents">
                                                    Documents
                                                </mat-option>
                                                <mat-option value="ExamData">
                                                    Exam
                                                </mat-option>
                                                <mat-option value="Course">
                                                    Course
                                                </mat-option>
                                                <mat-option value="Grievance">
                                                    Grievance
                                                </mat-option>
                                                <mat-option value="TransferScrutiny">
                                                    TransferScrutiny
                                                </mat-option>
                                                <mat-option value="LeavingScrutiny">
                                                    LeavingScrutiny
                                                </mat-option>
                                                <mat-option value="MigrationScrutiny">
                                                    MigrationScrutiny
                                                </mat-option>
                                                <mat-option value="TranscriptScrutiny">
                                                    TranscriptScrutiny
                                                </mat-option>
                                                <mat-option value="AdmCancelScrutiny">
                                                    AdmCancelScrutiny
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field>
                                            <mat-label>Choose an option</mat-label>
                                            <mat-select formControlName="FormRequired">
                                                <mat-option value=true>
                                                    Yes
                                                </mat-option>
                                                <mat-option value=false>
                                                    No
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field>
                                            <mat-label>Choose an option</mat-label>
                                            <mat-select formControlName="IsDefault">
                                                <mat-option value=true>
                                                    Yes
                                                </mat-option>
                                                <mat-option value=false>
                                                    No
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field>
                                            <mat-label>Choose an option</mat-label>
                                            <mat-select formControlName="FormVisible">
                                                <mat-option value = true>
                                                    Yes
                                                </mat-option>
                                                <mat-option value = false>
                                                    No
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                    <td class="text-center">
                                        <a class="btn-floating" title="Add">
                                            <i class="fa fa-plus" aria-hidden="true" (click)="addNew(i);" (click)="getData(i)"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>

                        </table>

                    </div>
                    <button
                        class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                        (click)="next()">Next
                    </button>
                    <button
                        class="mat-focus-indicator btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                        (click)="save()">Save
                    </button>
                </div>
            </div>
        </div>
    </form>
</body>